import * as actionTypes from '../../../../Store/Actions/actionTypes';
import * as notificationTypes from '../../../Components/Modules/Notification/notificationActions';
//import * as repositoryActions from '../../../Store/Actions/repositoryActions';
import axios from '../../../../Axios/axios';
import HmacSHA256 from 'crypto-js/hmac-sha256';
import UTF8 from 'crypto-js/enc-utf8';
import Base64 from 'crypto-js/enc-base64';

var SecurityManager = {
    salt: 'x6aOEWzbq6GWTFNdbyuo',
    username: localStorage.getItem('SecurityManager.username'),
    key: localStorage.getItem('SecurityManager.key'),
    ip: null,
    CreateUID: function () {

        var dt = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (dt + Math.random() * 16) % 16 | 0;
            dt = Math.floor(dt / 16);
            return (c === 'x' ? r : ((r & 0x3) | 0x8)).toString(16);
        });
        return uuid;
    },
    generate: function (username, password) {

        var uuid = this.CreateUID();

        // Set the username.
        SecurityManager.username = username; // SecurityManager.username || username;

        // Set the key to a hash of the user's password + salt.
        SecurityManager.key = Base64.stringify(HmacSHA256([password, SecurityManager.salt].join(':'), SecurityManager.salt));//SecurityManager.key || Base64.stringify(HmacSHA256([password, SecurityManager.salt].join(':'), SecurityManager.salt));

        // Set the client IP address.
        SecurityManager.ip = "192.168.56.1";

        // Persist key pieces.
        if (SecurityManager.username) {
            localStorage.setItem('SecurityManager.username',SecurityManager.username);
            localStorage.setItem('SecurityManager.key',SecurityManager.key);
        }

        // Get the (C# compatible) ticks to use as a timestamp. http://stackoverflow.com/a/7968483/2596404
        var ticks = ((new Date().getTime() * 10000) + 621355968000000000);

        // Construct the hash body by concatenating the username, ip, and userAgent.
        var message = [SecurityManager.username, SecurityManager.ip, navigator.userAgent.replace(/ \.NET.+;/, ''), ticks].join(':');
        message = [SecurityManager.username, "192.168.56.1", uuid, ticks].join(':');

        // Hash the body, using the key.
        var hash = HmacSHA256(message, SecurityManager.key);

        // Base64-encode the hash to get the resulting token.
        var token = Base64.stringify(hash);

        // var token = CryptoJS.enc.Base64.stringify(hash); ===== hashLeft = Convert.ToBase64String(hmac.Hash);
        // Include the username and timestamp on the end of the token, so the server can validate.
        // var tokenId = [SecurityManager.username, ticks].join(':');
        var tokenId = [SecurityManager.username, "192.168.56.1", uuid, ticks].join(':');

        // Base64-encode the final resulting token.
        var tokenStr = UTF8.parse([token, tokenId].join(':'));
        var tokenfinal = Base64.stringify(tokenStr);


  
        return tokenfinal;

    },
};

export const disconnect = () => {

    return {
        type: actionTypes.DISCONNECT,
        data: {}
    }
};

